// This is for standard quantities (the thousand's comma)
export const formatNumber = (value: number): string => {
  if (!value) return '0';
  return value.toLocaleString('en-US');
};

// This is for currency
export const formatCurrency = (value: number): string => {
  if (!value) return '0';

  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
